import { render, staticRenderFns } from "./InstrumentDetail.vue?vue&type=template&id=9ef438f4&scoped=true"
import script from "./InstrumentDetail.vue?vue&type=script&lang=js"
export * from "./InstrumentDetail.vue?vue&type=script&lang=js"
import style0 from "./InstrumentDetail.vue?vue&type=style&index=0&id=9ef438f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef438f4",
  null
  
)

export default component.exports